import { defineStore } from 'pinia';

export type ToastType = 'success' | 'error' | 'info';
export interface ToastItem { id: number; type: ToastType; message: string; }

let idCounter = 1;

export const useToastStore = defineStore('toast', {
  state: () => ({ items: [] as ToastItem[] }),
  actions: {
    push(type: ToastType, message: string, timeout = 4000) {
      const id = idCounter++;
      this.items.push({ id, type, message });
      if (timeout) setTimeout(() => this.remove(id), timeout);
    },
    remove(id: number) { this.items = this.items.filter(t => t.id !== id); }
  }
});

